import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, LoadingService, AuthenticationService } from '../_shared';

declare let $: any;

@Component({
  selector: 'app-legal-agreement',
  templateUrl: './legal-agreement.component.html',
  styleUrls: [
    './legal-agreement.component.css',
    '../../assets/css/core-login.css'
  ]
})
export class LegalAgreementComponent implements OnInit {
  private isChecked: boolean = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private loadingService: LoadingService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.load(false);
    this.authenticationService.isFirstTime.subscribe(value => {
      if (!value) {
        // redirect to dashboard if user has already logged in before
        this.router.navigate(['/dashboard']);
      }
      console.log('firsttimevalue on navbar', value);
    });
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  checkboxToggle($event: any) {
    if ($event.target.className !== 'modal-legal-agree') {
      this.isChecked = !this.isChecked;
    }
  }

  continueToDashboard() {
    this.load(true);

    this.userService.hasAgreeTerms().subscribe(
      res => {
        console.log(res);
        this.authenticationService.setIsFirstTime(!res.success);
        console.log('sending to auth serv', res.success);
      },
      x => {
        console.log('ERROR: ' + x);
      },
      () => {
        this.router.navigate(['/dashboard']);
      }
    );
  }

  setChecked($event: any) {
    this.isChecked = true;
    $('.modal-wrapper').scrollTop(0);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/legal-agreement/legal-agreement.component.ts